<template>
  <!-- 热门标签 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span
          v-if="isSearch == true"
          class="crumb"
          @click="
            $router.push({ name: 'search', params: { keyword: keyword } })
          "
          >搜索</span
        >
        <span v-if="isSearch == true">></span>
        <span
          v-if="isSearch == true"
          class="crumb"
          @click="
            $router.push({
              name: 'article_detail',
              params: { id: articleId, isSearch: true, keyWord: keyword }
            })
          "
          >{{ articleTitle }}</span
        >
        <span v-if="isSearch == true">></span>
        <span>{{ laberInfo.name }}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="content-list" v-if="list.length == 0">
            <div class="bigBox noData">
              <div class="list-box">暂无数据</div>
            </div>
          </div>
          <div class="content-list" v-else>
            <div v-for="(item, index) in list" :key="index" class="bigBox">
              <div class="list-box" @click="acticleDetail(item)">
                <div class="img" v-if="item.cover_url">
                  <img
                    :src="item.cover_url"
                    alt
                    v-if="typeof item.cover_url == 'string'"
                  />
                  <img :src="item.cover_url[0]" alt v-else />
                </div>
                <div class="suggest">
                  <p>{{ item.title }}</p>
                  <div class="message">
                    <div>
                      {{ item.visit_times }}
                      <span>阅读</span>
                    </div>
                    <div class="time">
                      {{ item.display_time | timefilters }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="morePage" v-if="show_page">
            <div @click="moreData">
              <p>加载更多</p>
              <div>
                <img src="@/assets/img/more.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <div class="right-box">
            <div class="top-laber" v-if="type == 'magazine'">
              <p class="tit">栏目信息</p>
              <div class="laber-info">
                <p>#{{ laberInfo.name }}</p>
                <div>
                  <span>{{ total_count }}篇文章</span>
                  <span
                    v-if="isShow && laberInfo.hasOwnProperty('parent_column')"
                    >{{ laberInfo.followers_count }}人关注</span
                  >
                </div>
                <div class="intro" v-if="laberInfo.summary">
                  简介：{{ laberInfo.summary }}
                </div>
                <div v-if="isShow && laberInfo.hasOwnProperty('parent_column')">
                  <el-button
                    :class="
                      laberInfo.follow == 'undefined' ? 'isActice' : 'follow'
                    "
                    v-if="laberInfo.follow"
                    @click="cancelFollowColumns(laberInfo.id)"
                    >已关注</el-button
                  >
                  <el-button
                    :class="laberInfo.follow == 'undefined' ? 'isActice' : ''"
                    v-else
                    @click="followColumns(laberInfo.id)"
                    >关注</el-button
                  >
                </div>
              </div>
            </div>
            <div class="top-laber" v-else>
              <p class="tit">标签信息</p>
              <div class="laber-info">
                <p>#{{ laberInfo.name }}</p>
                <div>
                  <span>{{ laberInfo.articles_count }}篇文章</span>
                  <span v-if="isShow"
                    >{{ laberInfo.followers_count }}人关注</span
                  >
                </div>
                <div class="intro" v-if="laberInfo.summary">
                  简介：{{ laberInfo.summary }}
                </div>
                <div v-if="isShow">
                  <el-button
                    :class="
                      laberInfo.follow == 'undefined' ? 'isActice' : 'follow'
                    "
                    v-if="laberInfo.follow"
                    @click="cancelFollowLaber(laberInfo.id)"
                    >已关注</el-button
                  >
                  <el-button
                    :class="laberInfo.follow == 'undefined' ? 'isActice' : ''"
                    v-else
                    @click="followLaber(laberInfo.id)"
                    >关注</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <LoginDialog
      :loginDialogs="loginDialogs"
      @child-event="getParentEvent"
    ></LoginDialog>
  </div>
</template>
<script>
import LoginDialog from "@/components/loginDialog";
import {
  getLaberArticleList,
  getLaberTagsList,
  getTagsDetailList,
  getMagazineDetailList,
  getMagazineList
} from "@/api/search";
import {
  getCancelColumn,
  getMangzineColumn,
  getCancelLaber,
  getTopicsLaber
} from "@/api/public";
import { getTdkList} from "@/api/tdk";

export default {
  components: {
    LoginDialog
  },
  data() {
    return {
      // 弹框
      loginDialogs: false,
      total_count: 0,
      name: "",
      page: 1,
      per: "8",
      show_page: false,
      list: [],
      laberInfo: {},
      params: {
        name: "",
        page: 1,
        per: "8"
      },
      pageInfo: {
        page: 1,
        per: "8"
      },
      id: "",
      isShow: true,
      type: "", //判断类型
      // 搜索页进入详情页
      articleTitle: "",
      isSearch: false,
      keyword: "",
      articleId: "",
      PId: ""
    };
  },
  methods: {
    getList() {
      var params = {
        page: this.page,
        per: this.per
      };
      if (this.type == "magazine") {
        getMagazineList(params, this.id).then(res => {
          this.list = this.list.concat(res.data.data);
          if (this.page >= res.data.meta.total_pages) {
            this.show_page = false;
          } else {
            this.show_page = true;
            this.page++;
          }
          this.total_count = res.data.meta.total_count;
        });
      } else {
        if (this.id != undefined) {
          getLaberArticleList(params, this.id).then(res => {
            this.list = this.list.concat(res.data.data);
            if (this.page >= res.data.meta.total_pages) {
              this.show_page = false;
            } else {
              this.show_page = true;
              this.page++;
            }
          });
        } else {
          this.$set(params, "name", this.name);
          getLaberTagsList(params).then(res => {
            this.list = this.list.concat(res.data.data);
            this.laberInfo.articles_count = res.data.meta.total_count;
            this.laberInfo.name = this.name;
            this.isShow = false;
            if (this.page >= res.data.meta.total_pages) {
              this.show_page = false;
            } else {
              this.show_page = true;
              this.page++;
            }
          });
        }
      }
    },
    moreData() {
      this.getList();
    },
    followColumns(id) {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        // 关注（杂志）
        getMangzineColumn(id).then(res => {
          // 杂志详情
          getMagazineDetailList(this.id).then(res => {
            this.laberInfo = res.data.data;
          });
        });
      }
    },
    // 取消关注（杂志）
    cancelFollowColumns(id) {
      if (localStorage.getItem("Authorization")) {
        getCancelColumn(id).then(res => {
          getMagazineDetailList(this.id).then(res => {
            this.laberInfo = res.data.data;
          });
        });
      } else {
        this.loginDialogs = true;
      }
    },
    // 关注（标签）
    followLaber(id) {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        getTopicsLaber(id).then(res => {
          // 标签详情
          getTagsDetailList(this.id).then(res => {
            this.laberInfo = res.data.data;
          });
        });
      }
    },
    // 弹框
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    // 取消关注（标签）
    cancelFollowLaber(id) {
      if (localStorage.getItem("Authorization")) {
        getCancelLaber(id).then(res => {
          getTagsDetailList(this.id).then(res => {
            this.laberInfo = res.data.data;
          });
        });
      } else {
        this.loginDialogs = true;
      }
    },
    // 文章详情
    acticleDetail(scope) {
      if (scope.article_type == "sound" || scope.article_type == "voice") {
        this.$router.push({
          name: "hot_detail",
          params: { id: scope.id, pTitle: scope.title }
        });
      } else {
        this.$router.push({
          name: "article_detail",
          params: { id: scope.id, title: scope.title, isRead: false }
        });
      }
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })

    this.name = this.$route.params.name;
    this.type = this.$route.params.type;
    this.id = this.$route.params.id;
    this.articleTitle = this.$route.params.articleTitle;
    this.keyword = this.$route.params.keyWord;
    this.isSearch = this.$route.params.isSearch;
    this.articleId = this.$route.params.articleId;

    this.resetParams(this, [
      "type",
      "id",
      "name",
      "articleTitle",
      "keyword",
      "isSearch",
      "articleId"
    ]);
    if (this.type == "magazine") {
      // 杂志详情
      getMagazineDetailList(this.id).then(res => {
        this.laberInfo = res.data.data;
      });
    } else {
      if (this.id != undefined) {
        getTagsDetailList(this.id).then(res => {
          this.laberInfo = res.data.data;
          this.$ba([
            ["ptype", "list"],
            ["acategory", "topic"],
            ["acname", "标签"],
            ["acategory2", "topic" + this.laberInfo.id],
            ["ac2name", this.laberInfo.name]
          ]);
        });
      }
    }
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.content-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 30px;
  .bigBox {
    display: inline-block;
    width: 48%;
    .list-box {
      background: #fff;
      margin-bottom: 30px;
      cursor: pointer;
      .img {
        width: 100%;
        height: 230px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          vertical-align: bottom;
        }
      }
      .suggest {
        padding: 26px 30px 20px 30px;
        p {
          font-size: 20px;
          min-height: 60px;
          line-height: 30px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 12px;
          text-align: justify;
        }
        .message {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: #999999;
          .time {
            margin-right: 24px;
          }
        }
      }
    }
  }

  .noData {
    line-height: 500px;
    width: 100%;
    text-align: center;
  }
}
.right-box {
  background: #ffffff;
  margin-bottom: 30px;
  .top-laber {
    text-align: center;
    padding: 30px 30px 10px 30px;
    .title {
      font-weight: bold;
    }
    ul {
      text-align: left;
      padding: 0;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      li {
        list-style-type: none;
        border: 1px solid #0091ff;
        border-radius: 18px;
        padding: 0px 16px;
        color: #0091ff;
        font-size: 16px;
        margin-right: 20px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
    .tit {
      font-size: 16px;
      font-weight: bold;
    }
    .laber-info {
      margin-top: 12px;
      padding: 0 30px 20px 30px;
      p {
        font-size: 16px;
        color: #0091ff;
        line-height: 32px;
      }
      div {
        font-size: 12px;
        color: #999999;
      }
      .intro {
        font-size: 14px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        cursor: pointer;
        margin-top: 10px;
      }
      .intro:hover {
        display: block;
      }
      .el-button {
        width: 80px;
        height: 30px;
        padding: 0;
        border-radius: 15px;
        background: #0091ff;
        color: #fff;
        margin-top: 10px;
        border: none;
      }
      .follow {
        background: #ffffff;
        color: #0091ff;
        border: 1px solid;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/hotLaber.vue